<template>
  <div>
    <svg
      viewBox="0 0 1279 179"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <!-- Generator: Sketch 60 (88103) - https://sketch.com -->
      <title>Path</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="start" transform="translate(-1.000000, -4419.000000)" fill="#FFC000">
          <g id="Call-To-Action" transform="translate(1.000000, 4419.000000)">
            <rect id="Rectangle" x="0" y="158" width="1280" height="418" />
            <path
              d="M0,63.0138232 C206.666667,147.032254 427.833333,147.032254 663.5,63.0138232 C899.166667,-21.0046077 1104.66667,-21.0046077 1280,63.0138232 L1280,179 L0,179 L0,63.0138232 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
    <div class="flex flex-col justify-center bg-brand-yellow px-10 sm:px-24 pt-10 pb-12">
      <h1 class="text-center text-3xl font-semibold">{{title}}</h1>

      <a v-if="linkText !== undefined" class="btn mx-auto mt-12" :href="linkUrl">{{linkText}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallToAction",
  props: {
    title: String,
    linkText: String,
    linkUrl: String
  },
  data() {
    return {};
  }
};
</script>

<style scoped></style>